import { useEffect } from 'react';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onCancel();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <>
      <div onClick={onCancel} className="confirm-modal__backdrop" />
      <div className="confirm-modal__container">
        <div className="ornate-border confirm-modal__body">
          <div>
            <h3 className="confirm-modal__title">{title}</h3>
            <p className="confirm-modal__message">{message}</p>
          </div>
          <div className="confirm-modal__actions">
            <button className="btn btn-secondary btn-small" onClick={onCancel} style={{ flex: 1 }}>
              {cancelLabel}
            </button>
            <button
              className={`btn btn-small ${variant === 'danger' ? 'btn-danger' : 'btn-primary'}`}
              onClick={onConfirm}
              style={{ flex: 1 }}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
